export enum VenueTableColumns {
  AbbreviationLocal = "abbreviationLocal",
  AbbreviationLatin = "abbreviationLatin",
  NameLocal = "nameLocal",
  NameLatin = "nameLatin",
  ExternalId = "externalId",
  VenueId = "venueId",
  TimeZone = "timeZone",
  CountryCode = "countryCode",
  Status = "status",
  Capacity = "capacity",
  Site = "site",
}
